/**
 * Application configuration file
 * Unified management of all API and image URL configurations
 */

// Environment configuration
const isProduction = process.env.NODE_ENV === 'production'
const isDevelopment = process.env.NODE_ENV === 'development'

// API configuration
export const API_CONFIG = {
  // API base URL
  BASE_URL: process.env.VUE_APP_API_BASE_URL || 'https://api.soninsaihan.com/',
  
  // Mall related APIs
  MALL_BASE_URL: 'https://mall.soninsaihan.com/',
  
  // Image server configuration - Development environment uses proxy, production environment uses direct domain
  IMAGE_BASE_URL: isDevelopment ? '/image/' : 'https://image.sainbainu.com/',
  
  // Upload server configuration
  UPLOAD_BASE_URL: 'https://upload.sainbainu.com/'
}

// Image configuration
export const IMAGE_CONFIG = {
  // Default images
  DEFAULT_LOGO: 'https://mall.soninsaihan.com/static/images/share-logo.png', // 使用绝对URL确保微信能访问
  DEFAULT_AVATAR: '/static/images/default-avatar.png',
  
  // Product images
  PRODUCT_IMAGE_BASE: isDevelopment ? '/image/uploads/products/' : 'https://image.sainbainu.com/uploads/products/',
  
  // Category images
  CATEGORY_IMAGE_BASE: isDevelopment ? '/image/uploads/categories/' : 'https://image.sainbainu.com/uploads/categories/',
  
  // User avatars
  USER_AVATAR_BASE: isDevelopment ? '/image/uploads/avatars/' : 'https://image.sainbainu.com/uploads/avatars/'
}

// WeChat configuration
export const WECHAT_CONFIG = {
  // WeChat Open Platform configuration
  OPEN_PLATFORM: {
    APP_ID: process.env.VUE_APP_WECHAT_OPEN_APP_ID || '',
    APP_SECRET: process.env.VUE_APP_WECHAT_OPEN_APP_SECRET || '',
    SCOPE: 'snsapi_login',
    REDIRECT_URI: isProduction 
      ? 'https://yourdomain.com/login' 
      : 'http://localhost:8080/login'
  },
  
  // WeChat Official Account configuration
  OFFICIAL_ACCOUNT: {
    APP_ID: process.env.VUE_APP_WECHAT_MP_APP_ID || '',
    APP_SECRET: process.env.VUE_APP_WECHAT_MP_APP_SECRET || '',
    SCOPE: 'snsapi_userinfo',
    REDIRECT_URI: isProduction 
      ? 'https://yourdomain.com/login' 
      : 'http://localhost:8080/login'
  }
}

// Payment configuration
export const PAY_CONFIG = {
  // WeChat Pay configuration
  WECHAT: {
    MCH_ID: process.env.VUE_APP_WECHAT_MCH_ID || '',
    API_KEY: process.env.VUE_APP_WECHAT_API_KEY || '',
    NOTIFY_URL: isProduction 
      ? 'https://yourdomain.com/api/pay/wechat/notify'
      : 'http://localhost:8080/api/pay/wechat/notify'
  },
  
  // WorldFirst (万里汇) Pay configuration
  WORLDFIRST: {
    CLIENT_ID: process.env.VUE_APP_WORLDFIRST_CLIENT_ID || '',
    CLIENT_SECRET: process.env.VUE_APP_WORLDFIRST_CLIENT_SECRET || '',
    PARTNER_ID: process.env.VUE_APP_WORLDFIRST_PARTNER_ID || '',
    NOTIFY_URL: isProduction 
      ? 'https://yourdomain.com/api/pay/worldfirst/notify'
      : 'http://localhost:8080/api/pay/worldfirst/notify',
    BASE_URL: process.env.VUE_APP_WORLDFIRST_BASE_URL || 'https://api.worldfirst.com/'
  }
}

// Application configuration
export const APP_CONFIG = {
  // Application name
  NAME: 'Tatar Trade Mall',
  
  // Application description
  DESCRIPTION: 'Discover more quality products and enjoy a seamless shopping experience',
  
  // Version information
  VERSION: '1.0.0',
  
  // Development environment identifier
  IS_DEVELOPMENT: isDevelopment,
  
  // Production environment identifier
  IS_PRODUCTION: isProduction
}

// Export default configuration
export default {
  API_CONFIG,
  IMAGE_CONFIG,
  WECHAT_CONFIG,
  PAY_CONFIG,
  APP_CONFIG
}